import { StyleSheet } from 'react-native';

export const createStyles = (isWide: boolean) =>
  StyleSheet.create({
    container: { flex: 1 },

    // ── Header ──────────────────────────────────────────────────────────────
    header: {
      position: 'sticky' as any,
      top: 0,
      zIndex: 100,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: isWide ? 48 : 20,
      paddingVertical: 14,
      borderBottomWidth: 1,
    },
    headerLogoContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    headerLogoIcon: { width: 28, height: 28, borderRadius: 6 },
    headerLogo: { fontSize: 22, fontWeight: '800' },
    headerActions: { flexDirection: 'row', alignItems: 'center', gap: 12 },
    headerThemeToggle: { padding: 8, borderRadius: 20 },
    headerSignIn: {
      paddingHorizontal: 18,
      paddingVertical: 8,
      borderRadius: 20,
      borderWidth: 1.5,
    },
    headerSignInText: { fontSize: 14, fontWeight: '600' },

    // ── Hero ────────────────────────────────────────────────────────────────
    heroSection: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingTop: isWide ? 80 : 52,
      paddingBottom: isWide ? 72 : 48,
      alignItems: 'center',
    },
    heroBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      paddingHorizontal: 14,
      paddingVertical: 6,
      borderRadius: 20,
      borderWidth: 1,
      marginBottom: 24,
    },
    heroBadgeText: { fontSize: 13, fontWeight: '600' },
    heroTitle: {
      fontSize: isWide ? 52 : 34,
      fontWeight: '800',
      textAlign: 'center',
      lineHeight: isWide ? 62 : 42,
      marginBottom: 8,
    },
    heroTitleAccent: {
      fontSize: isWide ? 52 : 34,
      fontWeight: '800',
    },
    heroSubtitle: {
      fontSize: isWide ? 18 : 15,
      textAlign: 'center',
      lineHeight: isWide ? 28 : 22,
      marginTop: 16,
      marginBottom: 36,
      maxWidth: 600,
    },
    heroProNote: {
      fontSize: 13,
      fontWeight: '600',
      marginBottom: 24,
      paddingHorizontal: 14,
      paddingVertical: 6,
      borderRadius: 20,
      overflow: 'hidden',
    },
    heroButtons: {
      flexDirection: isWide ? 'row' : 'column',
      gap: 12,
      alignItems: 'center',
    },
    heroPrimaryBtn: {
      paddingHorizontal: 32,
      paddingVertical: 14,
      borderRadius: 30,
      minWidth: 200,
      alignItems: 'center',
    },
    heroPrimaryBtnText: { fontSize: 16, fontWeight: '700' },
    heroSecondaryBtn: {
      paddingHorizontal: 32,
      paddingVertical: 14,
      borderRadius: 30,
      minWidth: 200,
      alignItems: 'center',
      borderWidth: 1.5,
    },
    heroSecondaryBtnText: { fontSize: 16, fontWeight: '600' },

    // ── Section ──────────────────────────────────────────────────────────────
    section: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingVertical: isWide ? 64 : 48,
    },
    sectionAlt: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingVertical: isWide ? 64 : 48,
    },
    sectionLabel: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 1.5,
      textTransform: 'uppercase',
      marginBottom: 10,
      textAlign: 'center',
    },
    sectionTitle: {
      fontSize: isWide ? 32 : 22,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 48,
    },

    // ── Steps ────────────────────────────────────────────────────────────────
    stepsRow: {
      flexDirection: isWide ? 'row' : 'column',
      gap: isWide ? 0 : 32,
    },
    stepItem: {
      flex: isWide ? 1 : undefined,
      alignItems: 'center',
      paddingHorizontal: isWide ? 24 : 0,
    },
    stepConnector: {
      width: 1,
      height: 40,
      marginTop: 16,
      alignSelf: 'center',
    },
    stepNumber: {
      width: 48,
      height: 48,
      borderRadius: 24,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 16,
    },
    stepNumberText: { fontSize: 20, fontWeight: '800' },
    stepTitle: { fontSize: 17, fontWeight: '700', textAlign: 'center', marginBottom: 8 },
    stepDesc: { fontSize: 14, textAlign: 'center', lineHeight: 21 },

    // ── Features ─────────────────────────────────────────────────────────────
    featuresGrid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 16,
    },
    featureCard: {
      width: isWide ? 'calc(50% - 8px)' as any : '100%',
      padding: 20,
      borderRadius: 16,
      borderWidth: 1,
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 14,
    },
    featureIconBox: {
      width: 40,
      height: 40,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    featureText: { flex: 1 },
    featureTitle: { fontSize: 15, fontWeight: '700', marginBottom: 4 },
    featureDesc: { fontSize: 13, lineHeight: 19 },

    // ── Related blog ──────────────────────────────────────────────────────────
    relatedCard: {
      borderRadius: 16,
      borderWidth: 1,
      padding: 24,
      flexDirection: isWide ? 'row' : 'column',
      alignItems: isWide ? 'center' : 'flex-start',
      gap: 20,
    },
    relatedIcon: {
      width: 48,
      height: 48,
      borderRadius: 12,
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    relatedContent: { flex: 1 },
    relatedLabel: { fontSize: 11, fontWeight: '700', letterSpacing: 1.2, marginBottom: 4 },
    relatedTitle: { fontSize: 17, fontWeight: '700', marginBottom: 6 },
    relatedSummary: { fontSize: 13, lineHeight: 19, marginBottom: 12 },
    relatedLink: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    relatedLinkText: { fontSize: 14, fontWeight: '600' },

    // ── Bottom CTA ────────────────────────────────────────────────────────────
    ctaSection: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingVertical: isWide ? 72 : 52,
      alignItems: 'center',
    },
    ctaTitle: {
      fontSize: isWide ? 36 : 24,
      fontWeight: '800',
      textAlign: 'center',
      marginBottom: 12,
    },
    ctaSubtitle: {
      fontSize: isWide ? 17 : 14,
      textAlign: 'center',
      marginBottom: 32,
      maxWidth: 480,
    },
    ctaBtn: {
      paddingHorizontal: 40,
      paddingVertical: 16,
      borderRadius: 30,
      minWidth: 220,
      alignItems: 'center',
    },
    ctaBtnText: { fontSize: 17, fontWeight: '700' },

    // ── Footer ────────────────────────────────────────────────────────────────
    footer: {
      paddingHorizontal: isWide ? 48 : 24,
      paddingVertical: 24,
      flexDirection: isWide ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      borderTopWidth: 1,
    },
    footerCopy: { fontSize: 13 },
    footerLinks: { flexDirection: 'row', gap: 20, flexWrap: 'wrap', justifyContent: 'center' },
    footerLink: { fontSize: 13, fontWeight: '500' },
  });
